import { useEffect, useState } from 'react';
import ARGameBody from '../ARGameBody';
import { isStoredUserInfoLSAction } from '@/redux/action/game';
import { IGame, IGameScreen } from '@/interface/game';
import GameScreen from './GameScreen';
import { useEventBus } from '@/hooks/useEventBus';
import { useAnalytics } from '@/hooks/useAnalytics';
import { analyticsEventType } from '@/constants/gameAnalytics';
import GameOverDefaultScreen from './GameOverDefaultScreen';

type GameScreenContentProps = {
  game: IGame;
};
const GameScreenContent = ({ game }: GameScreenContentProps) => {
  const [screen, setScreen] = useState<IGameScreen | undefined>(undefined);
  const [isGameStart, setIsGameStart] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [score, setScore] = useState<number | undefined>(undefined);
  const [isDefaulEndScreen, setIsDefaultEndScreen] = useState(false);
  const { onCreateAnalytics } = useAnalytics();

  const onSetScreen = async (type = 'START') => {
    const screens = game.config?.screens || [];
    const isLeadSubmitted_ = await isStoredUserInfoLSAction(game._id || '');
    if (type === 'START') {
      const leadStartScreen = screens.find(
        ele => ele.type === 'LEAD_SCREEN' && ele.position === 'START'
      );
      if (leadStartScreen && !isLeadSubmitted_) {
        setScreen(leadStartScreen);
        return;
      }
      const startScreen = screens.find(ele => ele.type === 'START_SCREEN');
      if (startScreen) {
        setScreen(startScreen);
        return;
      }
      setIsGameStart(true);
      setScreen(undefined);
    } else {
      const leadEndScreen = screens.find(
        ele => ele.type === 'LEAD_SCREEN' && ele.position === 'END'
      );
      if (leadEndScreen && !isLeadSubmitted_) {
        setScreen(leadEndScreen);
        return;
      }
      const screen = screens.find(ele => ele.type === type);
      if (screen) setScreen(screen);
      else setIsDefaultEndScreen(true);
    }
  };
  const onGameStart = () => {
    setScreen(undefined);
    setIsGameStart(true);
  };
  const onGameOver = (val: any) => {
    onSetScreen('END_SCREEN');
    setIsGameStart(false);
    onCreateAnalytics(analyticsEventType.GAME_OVER);
    if (val?.score != undefined) setScore(val?.score);
  };

  useEffect(() => {
    onSetScreen('START');
    onCreateAnalytics(analyticsEventType.GAME_VIEW);
  }, []);
  useEventBus('game_start', onGameStart);
  useEventBus('game_over', onGameOver);

  useEventBus('cta', () => onCreateAnalytics(analyticsEventType.CTA_CLICK));

  return (
    <>
      {screen && (
        <GameScreen
          screen={screen}
          onSetScreen={onSetScreen}
          gameId={game._id || ''}
        />
      )}
      {isGameStart && <ARGameBody game={game} />}
      {isDefaulEndScreen && <GameOverDefaultScreen />}
    </>
  );
};

export default GameScreenContent;
